import { Dropdown, Iconfont } from '@did/uikit'
import {
  RecordStatusFilterType,
  IRecordStatusFilterOption
} from '@did/das-balance-types'
import { useCallback, FormEvent, useMemo } from 'react'
import { cn } from '@did/tools'

export const RecordStatusFilter: RecordStatusFilterType = ({
  value,
  className,
  options,
  onInput
}) => {
  const selectOption = useMemo<IRecordStatusFilterOption>(
    () => options?.find((v) => v.value === value) || ({} as any),
    [options, value]
  )
  const onSelect = useCallback(
    (value: string) => {
      onInput(value as any)
    },
    [onInput]
  )

  const onFilterInput = useCallback((event: FormEvent<HTMLInputElement>) => {
    onInput((event.target as HTMLInputElement).value as any)
  }, [])

  return (
    <Dropdown align="start" options={options} onMenuClick={onSelect}>
      <div
        className={cn(
          'relative flex items-center justify-between cursor-pointer',
          className
        )}
      >
        <input
          value={selectOption.label}
          className="inline-block w-full h-[36px] pr-8 pl-3 rounded-lg border-0 text-tip-font-color outline-0 text-sm cursor-pointer font-medium bg-slate-600/10"
          type="text"
          readOnly
          onInput={onFilterInput}
        />
        <Iconfont
          className="absolute z-[0] top-[13.5px] right-[10px]"
          name="arrow-down"
          color="#31333E"
          size={12}
        />
      </div>
    </Dropdown>
  )
}
